import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section
      className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden"
      aria-label="首页横幅"
    >
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20gradient%20abstract%20background%20with%20soft%20flowing%20curves%20in%20deep%20red%20and%20dark%20amber%20tones%2C%20cinematic%20atmosphere%2C%20elegant%20minimal%20design%2C%20professional%20streaming%20platform%20aesthetic%2C%20smooth%20texture&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="私密视频首页背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
        fetchPriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
            红桃视频 · 西瓜视频 · 小蓝视频
          </h1>
          <p className="text-base md:text-xl text-white/85 mb-3 md:mb-4 max-w-2xl mx-auto leading-relaxed">
            高清画质不缓冲，茄子视频 · 久久视频 · 芒果视频全集资源一站畅享
          </p>
          <p className="text-sm md:text-base text-white/65 mb-6 md:mb-8">
            聚合六大视频平台 · 免费在线观看 · 流畅观影体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="#categories"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-medium text-sm md:text-base transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-play-circle-line mr-2"></i>立即观看
            </a>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3 bg-white/15 hover:bg-white/25 text-white rounded-full font-medium text-sm md:text-base backdrop-blur-sm transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-information-line mr-2"></i>了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}